export default {
  closeLabel: {
    id: 'lead_collection_popup_close_label',
    defaultMessage: 'Close',
  },
  ariaTitle: {
    id: 'lead_collection_popup_aria_title',
    defaultMessage: 'Notification',
  },
  ariaDescription: {
    id: 'lead_collection_popup_aria_description',
    defaultMessage: 'Notification from Back Market',
  },
}
